/** Dedicated reading page; only an owner-bound reference crosses in the hash.
 * It requires the existing NDG sign-in and refetches from the private mail API.
 */
import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import MailAnswer from "../components/universal_intent/renderers/MailAnswer";
import { parseMailReaderReference } from "../utils/mailReaderReference";
import "../components/universal_intent/UniversalIntentResponseSheet.css";

export default function EmailMessagePage() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const owner = typeof (user?.id || user?._id) === "string" ? (user.id || user._id) : "";
  const reference = useMemo(() => parseMailReaderReference(location.hash, owner), [location.hash, owner]);
  const presentation = useMemo(() => reference ? {
    kind: "mail-answer", title: "Your iCloud email", specialistId: "ui_icloud_mail",
    narration: "", data: { id: reference.id, untrusted: true },
  } : null, [reference]);

  return <div className="karen-email-page" data-testid="karen-email-page">
    <header><h1>Your iCloud email</h1><Link className="karen-panel-button" to="/settings/email-connections">Email search and settings</Link></header>
    <main>
      {loading ? <p role="status">Checking your NDG account…</p>
        : !reference ? <p role="alert">This email link is incomplete or belongs to a different NDG account. Return to email search and open the result again.</p>
        : <MailAnswer key={`${reference.owner}:${reference.id}:${reference.connection}`} presentation={presentation}
            standalone expectedOwner={reference.owner} expectedConnection={reference.connection} />}
    </main>
  </div>;
}
